import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import NewsSection from './components/NewsSection';
import FeaturedSection from './components/FeaturedSection';
import SpecialOfferBanner from './components/SpecialOfferBanner';

export default function Home() {
  return (
    <div style={{ fontFamily: "'Nunito', sans-serif" }}>
      <Navbar />
      <main>
        <HeroSection />
        <SpecialOfferBanner />
        <FeaturedSection />
        <NewsSection />

        {/* Categories Quick Nav */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl font-700 text-gray-800 text-center mb-3" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
              Shop by Category
            </h2>
            <p className="text-center text-gray-500 mb-10 text-sm">Everything your little one needs, at the best price</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
              {[
                { label: 'Clothing 1-3 yrs', icon: 'ri-shirt-line', color: '#FEF3D0', accent: '#F5B730', query: 'Clothing 1-3 yrs' },
                { label: 'Clothing 4-7 yrs', icon: 'ri-t-shirt-line', color: '#D1F5E8', accent: '#3DBD8A', query: 'Clothing 4-7 yrs' },
                { label: 'Clothing 8-12 yrs', icon: 'ri-clothes-line', color: '#EDE8FA', accent: '#8A6FD8', query: 'Clothing 8-12 yrs' },
                { label: 'Toys', icon: 'ri-gamepad-line', color: '#FEF3D0', accent: '#F5B730', query: 'Toys' },
              ].map(cat => (
                <Link
                  key={cat.label}
                  to={`/products?category=${encodeURIComponent(cat.query)}`}
                  className="flex flex-col items-center justify-center p-6 rounded-2xl cursor-pointer hover:scale-105 transition-transform duration-200"
                  style={{ backgroundColor: cat.color }}
                >
                  <div className="flex items-center justify-center w-14 h-14 rounded-full mb-3" style={{ backgroundColor: cat.accent + '22' }}>
                    <i className={`${cat.icon} text-2xl`} style={{ color: cat.accent }}></i>
                  </div>
                  <span className="text-sm font-600 text-gray-700 text-center" style={{ fontWeight: 600, fontFamily: "'Quicksand', sans-serif" }}>{cat.label}</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="py-20 relative overflow-hidden bg-brand-purple-pale">
          <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
            <span className="inline-block bg-brand-purple-light text-brand-purple text-xs font-600 px-4 py-1.5 rounded-full mb-4" style={{ fontWeight: 600 }}>
              Do your kids have clothes they&apos;ve outgrown?
            </span>
            <h2 className="text-3xl md:text-4xl font-700 text-gray-800 mb-4" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
              Donate or Sell with Us!
            </h2>
            <p className="text-gray-500 mb-8 text-base leading-relaxed">
              Give a second life to the clothes and toys your kids no longer use. We help other families while you care for the planet.
            </p>
            <Link
              to="/contact"
              className="inline-block bg-brand-yellow text-white px-8 py-3.5 rounded-full font-600 hover:bg-brand-yellow-dark transition-colors cursor-pointer whitespace-nowrap"
              style={{ fontWeight: 600 }}
            >
              Get in Touch
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
